/**
 * Alerts are added, shown, then removed.
 *
 * Uses the Alert class to shuttle stuff around.
 */
import Alert from "../../lib/alert";

export const ALERT_ADD = 'ALERT_ADD';
export const ALERT_ADD_MULTIPLE = 'ALERT_ADD_MULTIPLE';
export const ALERT_REMOVE = 'ALERT_REMOVE';
export const ALERT_REMOVE_MULTIPLE = 'ALERT_REMOVE_MULTIPLE';

export const addAlert = (alert: Alert) => ({type: ALERT_ADD, alert});

export const addAlerts = (alerts: Alert[]) => ({type: ALERT_ADD_MULTIPLE, alerts});

export const removeAlert = (alert: Alert) => ({type: ALERT_REMOVE, alert});

export const removeAlerts = (alerts: Alert[]) => ({type: ALERT_REMOVE_MULTIPLE, alerts});
